import { render, staticRenderFns } from "./NotificationIframe.vue?vue&type=template&id=69793018"
import script from "./NotificationIframe.vue?vue&type=script&lang=js"
export * from "./NotificationIframe.vue?vue&type=script&lang=js"
import style0 from "./NotificationIframe.vue?vue&type=style&index=0&id=69793018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports